/**
 * @file
 * Adds a hero's background video once the layer it plays in shows.
 *
 * A hidden video still downloads, so paragraph--hero.html.twig prints each
 * hero video inside a <template> in the layer for its screen width. CSS shows
 * the desktop video's layer from md (576px) up and the mobile video's layer
 * below md, so a screen downloads only the video it shows. A phone in
 * landscape is wider than md and gets the desktop video.
 *
 * When a layer shows, at load or after a resize, this swaps its template for
 * the video. An added video stays, so crossing md adds the other one too.
 * Each check reads the whole page and waits for the next animation frame, so
 * several attaches or resize events in one frame share a single check.
 */
(function (Drupal) {
  'use strict';

  var selector = 'template[data-hero-video]';
  var frame = null;
  var listening = false;

  function layerShows(template) {
    return template.parentElement.getClientRects().length > 0;
  }

  function addVideo(template) {
    var fragment = document.importNode(template.content, true);
    var videos = fragment.querySelectorAll('video');
    template.parentElement.replaceChild(fragment, template);
    Array.prototype.forEach.call(videos, function (video) {
      // A copied video can miss the muted state its attribute asks for, and
      // browsers block autoplay with sound, so set it and start playback.
      if (video.hasAttribute('muted')) {
        video.muted = true;
      }
      if (video.hasAttribute('autoplay')) {
        var playing = video.play();
        if (playing && playing.catch) {
          playing.catch(function () {});
        }
      }
    });
  }

  function checkTemplates() {
    frame = null;
    var waiting = 0;
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (template) {
      if (layerShows(template)) {
        addVideo(template);
      }
      else {
        waiting++;
      }
    });
    // Keep listening for resizes only while a template still waits.
    if (waiting && !listening) {
      window.addEventListener('resize', scheduleCheck);
      listening = true;
    }
    else if (!waiting && listening) {
      window.removeEventListener('resize', scheduleCheck);
      listening = false;
    }
  }

  function scheduleCheck() {
    if (frame === null) {
      frame = window.requestAnimationFrame(checkTemplates);
    }
  }

  Drupal.behaviors.heroVideo = {
    attach: function attach(context) {
      var root = context.querySelector ? context : document;
      if (root.querySelector(selector)) {
        scheduleCheck();
      }
    }
  };
})(Drupal);
